module.exports = __webpack_public_path__ + "static/image4-e89080c561920a41c5a6c25d6766cabc.png";